export default "__VITE_ASSET__ByPJe5yM__"